import { useMemo } from "react";
import { SalesPerson } from "../../../core/types/SalesPerson.model";
import { getMeetingDateStr } from "../../../utils/dateUtils";

function formatTime(dateStr: string) {
  const d = new Date(dateStr);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

type MeetingTimesProps = {
  selectedSalesPerson: SalesPerson;
  selectedDate: string;
};

const MeetingTimes = ({ selectedSalesPerson, selectedDate }: MeetingTimesProps) => {
  const { minTime, maxTime } = useMemo(() => {
    if (!selectedSalesPerson?.meetings) {
      return { minTime: null, maxTime: null };
    }

    const sameDayMeetings = selectedSalesPerson.meetings.filter(
      (m) => getMeetingDateStr(m.startTime) === selectedDate
    );

    if (sameDayMeetings.length === 0) {
      return { minTime: null, maxTime: null };
    }

    // ממירים ל-Date ומחשבים מינימום ומקסימום
    const times = sameDayMeetings.map((m) => new Date(m.startTime).getTime());
    const minTime = new Date(Math.min(...times));
    const maxTime = new Date(Math.max(...times));

    return { minTime, maxTime };
  }, [selectedSalesPerson, selectedDate]);

  return (
    <div>
      {minTime && maxTime ? (
        <>
          {formatTime(minTime.toISOString())} - {formatTime(maxTime.toISOString())}
        </>
      ) : (
        <span>No meetings on this date</span>
      )}
    </div>
  );
};

export default MeetingTimes;
